import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../../core/configuration/properties-settings";
import { Classificazione } from '../../../../models/classificazione';
import { ClassificazioneSezione } from '../../../../models/sezioni/classificazione-sezione';
import { ClassificazionePraticaAddComponent } from './classificazione-pratica-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [classificazione-mod-add]',
  templateUrl: 'classificazione-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ClassificazioneModAddComponent {
  @Input() idFormPratica: string;
  @Output() onReturn: EventEmitter<ClassificazioneSezione> = new EventEmitter<ClassificazioneSezione>();
  @ViewChild('formClassificazioneAdd') formClassificazioneAdd: ClassificazionePraticaAddComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(idSezione: string, urlCreateClassificazione: string, idPratica: string, listaClassificazioni: Classificazione[]) {
    this.formClassificazioneAdd.inizializza(idSezione, urlCreateClassificazione, idPratica, listaClassificazioni);
    openModal('modalClassificazioneAdd');
  }

  createForm() {
    this.formClassificazioneAdd.createForm();
  }

  reset() {
    this.formClassificazioneAdd.createForm();
  }

  manageModal(classificazioneSezione: ClassificazioneSezione) {
      closeModal('modalClassificazioneAdd');
      if (classificazioneSezione) {
        this.onReturn.emit(classificazioneSezione);
      }
  }
}
